module.exports = __webpack_public_path__ + "img/HandCoins.3e81aa2a.svg";